import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import BaseAutoCompleteList from './base-autocomplete-list';

import KeyMap from '../../../../scripts/utilities/keymap';

const mapStateToProps = state => ({
  airportsList: state.Booker.airportsList,
  airportsListFiltered: state.Booker.airportsListFiltered,
  destinationAirport: state.Booker.destinationAirport,
  helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
  originAirport: state.Booker.originAirport,
});

class AutocompleteDestination extends Component {
  constructor() {
    super();

    this.state = {
      isActive: null,
      searchTerm: null,
    };
  }

  render() {
    const {
      airportsListFiltered,
      destinationAirport,
      dispatch,
      helperTraslatedCopy,
      placeholderCopyID,
      resultItem,
    } = this.props;

    const {
      isActive,
      searchTerm,
    } = this.state;

    const inputClasses = cx({
      'Autocomplete-input': true,
      'Autocomplete-input--transparent': !isActive /* !isActive && search */,
    });

    const showClearButton = searchTerm && searchTerm.length > 0;

    return (
      <div className='Autocomplete'>
        { Object.keys(destinationAirport).length > 0 &&
          <div className='Autocomplete-placeholderButton'>
            <span className='SelectedAirport-airportCity'>{ destinationAirport.city }</span>&nbsp;
            <span className='SelectedAirport-airportCode'>{ destinationAirport.code }</span>
          </div>
        }
        <input
          aria-label={ helperTraslatedCopy.getFormatMessageFromcopyId(placeholderCopyID) }
          className={ inputClasses }
          onBlur={ (e) => this.handleBlur(e) }
          onChange={ (e) => this.handleChange(e) }
          onFocus={ (e) => this.handleFocus(e) }
          placeholder={ resultItem || Object.keys(destinationAirport).length > 0 ? null : helperTraslatedCopy.getFormatMessageFromcopyId(placeholderCopyID) }
          ref={ ref => this.inputDestination = ref }
        />
        { isActive &&
          <BaseAutoCompleteList
            airportsList = { airportsListFiltered }
            dispatch= { dispatch }
            handleBlur = { (e) => this.handleBlur(e) }
            isActive = { isActive }
            searchTerm={ searchTerm }
          />
        }
        { showClearButton ? this.renderClearButton() : null }
      </div>
    );
  }

  handleBlur = (e) => {
    if (e) {
      e.preventDefault();
      const { changeLabelDestination } = this.props;

      e.target.value = '';

      changeLabelDestination();

      this.setState({
        isActive: false,
        searchTerm: '',
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      searchTerm: e.target.value,
    });
  }

  handleClearButtonEnter(e) {
    const { handleClear } = this.props;

    if (e.keyCode == KeyMap.ENTER || e.keyCode == KeyMap.RETURN ) {
      handleClear();

      document.activeElement.focus();
    }
  }

  handleClearClick(e) {
    e.preventDefault();
    e.target.value = '';

    this.setState({
      searchTerm: '',
    });

    this.inputDestination.value = '';
    document.activeElement.focus();
  }

  handleFocus = (e) => {
    const { changeLabelDestination } = this.props;
    e.target.value = '';

    changeLabelDestination();

    this.setState({
      isActive: true,
    });
  }

  renderClearButton() {
    return (
      <button
        className='Booker-clearButton Icon Icon--xThin'
        onKeyUp={ (e) => this.handleClearButtonEnter(e) }
        onMouseDown={ (e) => this.handleClearClick(e) }
        type='button'
        value='clear' />
    );
  }
}

AutocompleteDestination = connect(mapStateToProps)(AutocompleteDestination);

export default AutocompleteDestination;